import { render, staticRenderFns } from "./SundryCreditorListView.vue?vue&type=template&id=4dc0c791"
import script from "./SundryCreditorListView.vue?vue&type=script&lang=js"
export * from "./SundryCreditorListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports